/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens to fantasy points on a DNF or DQ?`)
};

const es_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué ocurre con los puntos fantasy en un abandono o descalificación?`)
};

const de_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was passiert mit Fantasy-Punkten bei einem Ausfall oder einer Disqualifikation?`)
};

const nl_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat gebeurt er met fantasy-punten bij een uitval of diskwalificatie?`)
};

const fr_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que se passe-t-il pour les points fantasy en cas d'abandon ou de disqualification ?`)
};

const it_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa succede ai punti fantasy in caso di ritiro o squalifica?`)
};

const pt_br2_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que acontece com os pontos fantasy em um abandono ou desclassificação?`)
};

const pt_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que acontece aos pontos fantasy num abandono ou desqualificação?`)
};

const ja_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リタイアや失格になるとファンタジーポイントはどうなりますか？`)
};

const zh_f1_fp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退赛或取消资格会对梦幻积分产生什么影响？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_fp_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_fp_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_fp_faq3_q", locale)
	if (locale === "en") return en_f1_fp_faq3_q(inputs)
	if (locale === "es") return es_f1_fp_faq3_q(inputs)
	if (locale === "de") return de_f1_fp_faq3_q(inputs)
	if (locale === "nl") return nl_f1_fp_faq3_q(inputs)
	if (locale === "fr") return fr_f1_fp_faq3_q(inputs)
	if (locale === "it") return it_f1_fp_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_fp_faq3_q(inputs)
	if (locale === "pt") return pt_f1_fp_faq3_q(inputs)
	if (locale === "ja") return ja_f1_fp_faq3_q(inputs)
	return zh_f1_fp_faq3_q(inputs)
};